export const getDateFromTime = (
    hours: number,
    minutes = 0
): Date => {
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return new Date(date);
}
